export default {
  listTitleTable: {
    Symbol: 'ticker',
    TotalQuantity: 'total Quantity',
    CostPrice: 'cost Price',
    MarketPrice: 'market Price',
    InitialValue: 'Initial Value',
    StockValue: 'Stock Value',
    UnrealizedProfit: 'unrealized Profit',
  },
  buttonTitle: {
    Reload: 'Reload',
  },
  title: {
    TotalCost: 'Total Cost',
    TotalUnrealizedProfit: 'Total unrealized profit',
  },
  listPopupTitle: {
    TradeQuantity: 'Trade quantity',
    BlockedQuantity: 'Blocked quantity',
    ReceivingRightQuantity: 'Receiving right quantity',
    ReceivingQuantity: 'Receiving quantity',
    ReceivingT0Quantity: 'T0',
    ReceivingT1Quantity: 'T1',
    ReceivingT2Quantity: 'T2',
  },
  Table: {
    TABLE_FOOTER_TEXT_WITH_UNIT:
      'Portfolio data displayed at FiinTrade is provided by DNSE. The calculated data may differ from the data shown on https://entradex.dnse.com.vn/ due to different calculation methods.',
  },
};
